import { render, staticRenderFns } from "./taskDialog.vue?vue&type=template&id=6b204526&scoped=true&"
import script from "./taskDialog.vue?vue&type=script&lang=js&"
export * from "./taskDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskDialog.vue?vue&type=style&index=0&id=6b204526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b204526",
  null
  
)

export default component.exports